import { render, staticRenderFns } from "./ShippingList.vue?vue&type=template&id=10613254&scoped=true"
import script from "./ShippingList.vue?vue&type=script&lang=js"
export * from "./ShippingList.vue?vue&type=script&lang=js"
import style0 from "./ShippingList.vue?vue&type=style&index=0&id=10613254&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10613254",
  null
  
)

export default component.exports